<template>
	<div ref="idPan" style="height:100%;">
		<popwin style="width:100%; height:100%;" :ctrl="ctrlWin"></popwin>

		<div style="flex: 0 0 auto; width:100%; height:50px;">
			<div class="SiftPanel">
				<div class="Capt DIVNoSelect" style="flex:0 0 auto; margin-top:-1px; margin-left:20px;">{{getLangText('付款日期')}}</div>
				<input type="text" style="width:120px;" maxlength=30 v-model="findPayDay" placeholder="YYYYMMDD">

				<div class="Capt DIVNoSelect" style="flex:0 0 auto; margin-top:-1px; margin-left:20px;">{{getLangText('付款流水号')}}</div>
				<input type="text" style="width:250px;" maxlength=30 v-model="findOrderNo">

				<div class="Capt DIVNoSelect" style="flex:0 0 auto; margin-top:-1px; margin-left:20px;">{{getLangText('设备编码')}}</div>
				<input type="text" style="width:250px;" maxlength=30 v-model="findHdcode">

				<div class="Capt DIVNoSelect" style="flex:0 0 auto; margin-top:-1px; margin-left:20px;">{{getLangText('退款流水号')}}</div>
				<input type="text" style="width:250px;" maxlength=30 v-model="findRefundNo">

				<div class="NButton DIVNoSelect" style="width:32px; height:32px; background:url(../static/images/op_fin.png); margin-top:-1px; margin-left:10px;" @click="onListClick"></div>
			</div>
		</div>

		<div ref="idTablePan" style="width:100%; border:0px solid red; display:flex; align-items:center;">
			<ctable :ctrl="ctrlTable"></ctable>
		</div>

		<div style="flex: 0 0 auto; width:100%; height:30px; border:0px solid red;">
			<cpage :key="keyFind" :ctrl="ctrlPage" style="margin-left:0px;"></cpage>
		</div>
	</div>
</template>

<script>

import ctable     from '../cf/ctable'
import popwin     from '../cf/popwin'
import cselect    from '../cf/cselect'
import cpage      from '../cf/cpage'

export default {
	name: 'payList',
	components:{
		ctable, popwin, cselect, cpage
	},
	data () {
		return {
			keyFind: 1000,
			findPayDay: "",                         // 付款日期
			findOrderNo: "",                        // 付款流水号
			findRefundNo: "",                       // 退款流水号
			findHdcode: "",                         // 设备编码
			ctrlPage: {
				havNote: true,                  //是否显示提示信息
				havGo: true,                    //是否显示页号输入及按钮
				total: 0,                       //总记录数
				pageSize: 10,                   //每页记录条数
				pageIdx: 0,                     //当前页码
				cont:[this.getLangText('共'),this.getLangText('条记录,'),this.getLangText('页'),this.getLangText('条/页'),this.getLangText('页码'),'Go'],
				qryFunc: this.onListClick,      //查询回调函数
			},

			ctrlWin:{                               // 弹出窗口控制属性
				w2: 500,
				h2: 440,
				captHeight: 40,                     // 标题栏高度
				captCont: "",                       // 标题
				rcallFunc: this.onListClick,                 // 指定关闭弹出窗后需要执行的回调方法
			},
			ctrlTable: {                            // 表格控制参数
				headHeight: 50,                     // 表头行的高度
				dataHeight: 46,                     // 数据行的高度
				isCheck: false,                     // 第一列, 是否显示为复选框
				isSplit: false,                     // 固定列、数据列、操作列间是否有渐变分隔
				dataHeads:{                         // 表格表头定义
					head1:[                         // 固定列表头
						{ capt:this.getLangText("设备名称"), width:200 },
					],
					head2:[                         // 数据列表头
						{ width:140, capt:this.getLangText('付款日期') },
						{ width:320, capt:this.getLangText('付款流水号') },
						{ width:120, capt:this.getLangText('支付通道') },
						{ width:180, capt:this.getLangText('照片数') },
						{ width:130, capt:this.getLangText('付款金额') },
						{ width:120, capt:this.getLangText('退款状态') },
						{ width:320, capt:this.getLangText('退款流水号') },
						{ width:150, capt:this.getLangText('退款金额') },
						{ width:300, capt:this.getLangText('设备编码') },
						{ width:200, capt:this.getLangText('添加时间') },
						{ width:200, capt:'' },
					],
					head3:[                         // 操作列表头
						{ capt:this.getLangText('操作'), width:80 },
					],
				},
				datas:{ data1:[ ], data2:[ ], data3:[ ] },  // 表格数据定义
			},
		}
	},
	mounted: function(){
		if( !parseInt(this.login.userId) ) return;

		this.findPayDay = this.getDateInt(0);

		this.$refs["idTablePan"].style["height"] = (this.$refs["idPan"].offsetHeight - 86)+"px";

		this.ctrlTable.self.show();

		this.onListClick();
	},
	computed:{

	},
	methods:{
		onResize: function( ){
			this.$refs["idTablePan"].style["height"] = (this.$refs["idPan"].offsetHeight - 86)+"px";

			this.childResize( this );
		},
		/* 查询按钮事件响应 */
		onListClick: function(){
			let body={ pageSize:this.ctrlPage.pageSize, curPage:this.ctrlPage.pageIdx-1,
						cprWaterno: this.findOrderNo,
						cprRefundWaterno: this.findRefundNo,
						devHdcode: this.findHdcode,
						cprDeviceCustId: this.login.custId
					};
			if( this.findPayDay!="" ) body.cprLocalYmd = parseInt(this.findPayDay);

			this.doTrade( "POST", ServAddr+"/api/rec/payRecQry", this.onListOK, true, body, null );
		},
		onListOK: function( res ){
			this.appRoot.app.closeDlgRun();

			let data=res.body;
			if( data.code != "200" )
			{
				this.appRoot.app.showDlgTip( 1200, this.getErrorText(data.code), this.CLR.Err );
				return;
			}

			this.ctrlTable.datas.data1=[];
			this.ctrlTable.datas.data2=[];
			this.ctrlTable.datas.data3=[];

			for(let i=0; i<data.body.list.length; i++ )
			{
				let item=data.body.list[i];
				this.ctrlTable.datas.data1.push([ item.devName ]);

				this.ctrlTable.datas.data2.push( [ this.splitYMD(item.cprLocalYmd, 1), item.cprWaterno, item.cprPayChannel, item.cprPhotoCnt,
							this.Fen2Yuan(item.cprPayMoney), this.getRefundStsText(item.cprRefundSts), item.cprRefundWaterno,
							this.Fen2Yuan(item.cprRefundMoney), item.devHdcode,
							item.cprAddDatetime.substring(0,19).replace("T",  " "), '' ] );

				this.ctrlTable.datas.data3.push([ "" ]);
			}

			if( this.login.custId == gPlatCustId )
				 this.ctrlTable.dataHeads.head3[0].width = 150;
			else this.ctrlTable.dataHeads.head3[0].width = 80;

			this.ctrlTable.self.show();
			this.ctrlPage.total = data.body.allCnt;
			this.keyFind++;
		},
	}
}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// payList.vue?6b278930